import {
  useGmailDisconnect,
  useGmailRedirectUrl,
  useUpdateGmailSender,
} from '@/hooks/actions/use-email-integration-actions';
import type { EmailMetadata } from '@fluenceur/types';
import EmailIntegration, { type EmailIntegrationConfig } from './EmailIntegration';
import type { IntegrationCardVariant } from './IntegrationCard';
import GoogleDataUseNotice from './GoogleDataUseNotice';

const GMAIL_CONFIG: EmailIntegrationConfig = {
  i18nPrefix: 'integrations.gmail',
  callbackParam: 'gmail',
  icon: '/images/integrations/gmail.svg',
};

interface GmailIntegrationProps {
  id: string | null;
  isConnected: boolean;
  needsRefresh?: boolean;
  senderEmail?: string;
  metadata?: EmailMetadata;
  variant?: IntegrationCardVariant;
  detailHref?: string;
}

const GmailIntegration = (props: GmailIntegrationProps) => (
  <EmailIntegration
    {...props}
    config={GMAIL_CONFIG}
    redirectMutation={useGmailRedirectUrl()}
    disconnectMutation={useGmailDisconnect()}
    updateSenderMutation={useUpdateGmailSender()}
    disclosure={<GoogleDataUseNotice />}
  />
);

export default GmailIntegration;
